import { render, staticRenderFns } from "./companyLeavesComponent.vue?vue&type=template&id=2b20eaee&"
import script from "./companyLeavesComponent.vue?vue&type=script&lang=js&"
export * from "./companyLeavesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports